module.exports = __webpack_public_path__ + "static/img/正面定位框选.70e8bb67.gif";